import React from "react";
import "./taglabel.scss";
import { Checkbox } from "@progress/kendo-react-inputs";
// interface to declare all our prop types
interface Props {
  label?: string;
  name?: string;
  value?: number | null;
  defaultChecked?: boolean;
  disabled?: boolean;
  handleChange?: any,
  checked:boolean

}

const TagLabel: React.FC<Props> = ({
  label = '',
  name = '',
  value,
  checked,
  defaultChecked,
  handleChange,
  ...rest
}) => {
  return (
    <label className="taglabel">
      <Checkbox value={value}
        onChange={handleChange}
        checked={checked}
        label={label} />
      {/* <span className="checkmark"></span>
      <span className="value"><Icon icon="charm:tick" />{label}</span> */}
    </label>
  );
};

export default TagLabel;


